import styled from 'styled-components';

import { ChatAreaContainer } from '../../styled-components/ChatAreaContainer';

export const TranscriptWrapper = styled(ChatAreaContainer)<{
  $background?: string;
  $border?: string;
  $margin?: string;
  $borderRadius?: string;
}>`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  ${({ $background }) => $background && `background: ${$background};`}
`;
